module.exports = __webpack_public_path__ + "img/amount_paid_icon.0aaf9a33.svg";